import React from 'react'

/** Label + value + optional hint. */
export default function StatCard({ label, value, hint, className = '' }) {
  return (
    <div className={`rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-xl ${className}`}>
      <div className="text-2xl font-bold text-white tabular-nums">{value}</div>
      <div className="mt-1 text-sm font-medium text-white/70">{label}</div>
      {hint && <div className="mt-0.5 text-xs text-white/50">{hint}</div>}
    </div>
  )
}
